/*
    Store module mutations examples

*/

// Boilerplate for generic mutations use in almost any module
import * as generic from '@/store/generic/mutations/result-status.js'

export function clearError (state, payload) {
  generic.clearError(state, payload)
}

export function setError (state, payload) {
  generic.setError(state, payload)
}

export function setSuccess (state, payload) {
  generic.setSuccess(state, payload)
}

export function setProcessing (state, payload) {
  generic.setProcessing(state, payload)
}


// Start new mutation here
// eslint-disable-next-line no-unused-vars
export function setUser (state, payload) {
  state.user = payload
}

export function setUsers (state, payload) {
  state.users = payload
}

export function delUser (state, payload) {
  const users = state.users.filter(res => res.id !== payload.id)
  state.users = users
}

export function setResetPassword (state, payload) {
  const users = state.users.map(res => {
    if(res.id === payload.id){ res = payload}
    return res
  })
  state.users = users
}

export function setStudent (state, payload) {
  state.student = payload
}

export function setStudents (state, payload) {
  state.students = payload
}

export function delStudent (state, payload) {
  const students = state.students.filter(res => res.id !== payload.id)
  state.students = students
}

export function setResetStudentPassword (state, payload) {
  const students = state.students.map(res => {
    if(res.id === payload.id){ res = payload}
    return res
  })
  state.students = students
}
